import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {Paginate} from '../../search-document-sign/search-document-sign.component';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service';
import {Location} from '@angular/common';
import {Message} from '../../../../../../../core/class/message';
import {CommonService} from '../../../../../../../core/services/common.service';

/**
 * The document model.
 */
export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  isSignDigitalCertificate: boolean;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
}

/**
 * document source.
 */
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-sign-document-waiting-confirm-list',
  templateUrl: './sign-document-waiting-confirm-list.component.html',
})

/**
 * Sign document list component.
 */
export class SignDocumentWaitingConfirmListComponent implements OnInit {


  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  public static CONFIRM_ACTION_NON_CERTIFICATE = 'confirm2';
  public static DECLINE_ACTION = 'decline';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  public static TYPE_CONTRACT_NON_CERTIFICATE = 'non certificate';

  public static TYPE_CONTRACT_WITH_CERTIFICATE = 'with certificate';

  public static TYPE_CONTRACT_MIX_CERTIFICATE = 'mix certificate';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;

  dataSource: any = [];

  tmp: any;

  paginate: Paginate;

  documents = new Document();

  noOfFiles: 0;

  conTractWithCertificate: 0;
  typeContracts: string;
  conTractWithoutCertificate: 0;
  notifyWarning: string;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'noOfFile',
    'allName',
    // 'symbol',
  ];

  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      signOption: string,
      slotDocuments: any,
      filterSignAll: any
    },
    private location: Location,
    private router: Router,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private message: Message,
    private commonService: CommonService,
  ) {
    this.signOption = data.signOption;
    this.slotDocuments = data.slotDocuments;
    this.filterSignAll = data.filterSignAll;
  }

  /**
   * Initialize data.
   */
  ngOnInit() {
    if (this.signOption === SignDocumentWaitingConfirmListComponent.SIGN_ALL) {
      this.loadDocumentsByApproveAll();
    } else {
      console.log('slot: ' + JSON.stringify(this.slotDocuments));
      const dataSource = this.slotDocuments.value.map(item => ({
        ...item,
        contractName: item.name,
      }));
      console.log('dataSourcedataSource', dataSource);

      dataSource.sort((a, b) => {
        if (a.isSignDigitalCertificate === true && b.isSignDigitalCertificate === false) {
          return -1;
        } else if (a.isSignDigitalCertificate === false && b.isSignDigitalCertificate === true) {
          return 1; // b đứng trước a
        } else {
          return 0;
        }
      });
      this.noOfFiles = dataSource.reduce(function (s, a) {
        return s + a.contractAttachments.length;
      }, 0);
      // if (!dataSource.some(item => item.isSignDigitalCertificate === true)) {
      //   this.typeContracts = SignDocumentWaitingConfirmListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
      // } else if (!dataSource.some(item => item.isSignDigitalCertificate === false)) {
      this.typeContracts = SignDocumentWaitingConfirmListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
      // } else {
      //   this.typeContracts = SignDocumentWaitingConfirmListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
      // }
      const validData = dataSource.filter(x => x.status === 2 && x.cStatus !== 3 && x.cStatus !== 5);
      this.conTractWithCertificate = validData.filter((item) => item.isSignDigitalCertificate === true).length;
      this.conTractWithoutCertificate = validData.filter((item) => item.isSignDigitalCertificate === false).length;

      const notifyWarningStr = this.commonService.format(this.message.getMessage('messages.messages.warning_multi_sign_lot_wait'), dataSource.length - validData.length, dataSource.length, validData.length);
      this.notifyWarning = validData.length === dataSource.length ? '' : notifyWarningStr;
      this.dataSource = validData;

    }
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    this.actions.next(SignDocumentWaitingConfirmListComponent.CLOSE_ACTION);
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
localStorage.setItem('dataPopupSignProcess',JSON.stringify(this.dataSource));
    // if (this.dataSource.some((item: any) => item.isSignDigitalCertificate === true)) {
    //   this.actions.next(SignDocumentWaitingConfirmListComponent.CONFIRM_ACTION);
    // } else {
      // this.dialog.open(ApprovalDocumentComponent, {
      //   width: '40%',
      //   data: {
      //     document: this.dataSource
      //   }
      // });
      this.actions.next(SignDocumentWaitingConfirmListComponent.CONFIRM_ACTION);
    // }

  }

  /**
   * Load document by sign all.
   */
  private loadDocumentsByApproveAll() {
const data = this.filterSignAll;
data.type = 'all';
    this.documentService.searchDocumentWaitingConfirm(data)
      .subscribe(rs => {
        if (rs && rs.data) {
          this.dataSource = rs.data.dataRow;
          // this.dataSource.sort((a, b) => {
          //   if (a.isSignDigitalCertificate === true && b.isSignDigitalCertificate === false) {
          //     return -1;
          //   } else if (a.isSignDigitalCertificate === false && b.isSignDigitalCertificate === true) {
          //     return 1; // b đứng trước a
          //   } else {
          //     return 0;
          //   }
          // });
          this.noOfFiles = this.dataSource.reduce(function (s, a) {
            return s + a.contractAttachments.length;
          }, 0);
        }
        // if (!this.dataSource.some(item => item.isSignDigitalCertificate === true)) {
        //   this.typeContracts = SignDocumentWaitingConfirmListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
        // } else if (!this.dataSource.some(item => item.isSignDigitalCertificate === false)) {
        //   this.typeContracts = SignDocumentWaitingConfirmListComponent.TYPE_CONTRACT_WITH_CERTIFICATE;
        // } else {
          this.typeContracts = SignDocumentWaitingConfirmListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
        // }
        this.conTractWithCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === true).length;
        this.conTractWithoutCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === false).length;
      });
  }

}
